export const SET_LOADING = "SET_LOADING";

export const SET_PAGE = "SET_PAGE";
export const SET_PAGE_RECORD = "SET_PAGE_RECORD";
export const SET_TOTAL_RECORDS = "SET_TOTAL_RECORDS";

//Subscription
export const GET_SUBSCRIPTION_PRODUCT_LIST = "GET_SUBSCRIPTION_PRODUCT_LIST";
export const GET_ACTIVE_SUBSCRIPTION_LIST = "GET_ACTIVE_SUBSCRIPTION_LIST";
